<template>
  <div class="container-users">
    <modal-header>
      Invite guests to Room via email
    </modal-header>

    <div v-if="validEmails" class="emails-list">
      <div v-for="email in validEmails" :key="email" class="item">
        <div class="email-wrapper">
          <span class="email">{{ email }}</span>
        </div>
        <span class="remove" :id="email" @click="removeEmailFromList">
          <p class="remove-x"></p>
        </span>
      </div>
    </div>

    <div class="emails-list-inputs">
      <TextInput
        inset
        multiline
        focusOnMounted
        placeholder="Add user email(s) separated by commas or spaces"
        v-model="emailInput"
        @onInput="onEmailInput"
      />
    </div>

    <FooterButtons>
      <btn colour="ghost" @onClick="cancel">
        <template #text>Cancel</template>
      </btn>
      <btn colour="green" @onClick="addAllEmails" :disabled="!allowAddUsers">
        <template #text>Save</template>
      </btn>
    </FooterButtons>
  </div>
</template>

<script>

import { mapGetters, mapActions } from 'vuex';

import { TextInput, FooterButtons } from '@/framework';
import ModalHeader from '@/framework/modals/components/newModalHeader.vue';
import EmailListMixin from './EmailListMixin.js'
import InviteExternalGuestsModal from '@/components/modals/admin/InviteExternalGuestsModal.vue';

export default {
  name: 'InviteExternalGuestsByEmailModal',
  components: { ModalHeader, TextInput, FooterButtons },
  mixins: [ EmailListMixin ],
  props: {
    resetData: Function,
    areaUsersNo: { type: Number, default: 0 }
  },
  computed: {
    ...mapGetters(['getSpacePageId']),
    allowAddUsers() {
      return this.validEmails.length || this.emailInput !== '';
    }
  },
  methods: {
    ...mapActions([
      'handleInviteUsersToSpaceByEmail',
      'modal/close',
      'modal/open'
    ]),
    ...mapActions('guest', ['handleInviteGuestsByEmail']),
    async sendEmails() {
      let res = await this.handleInviteGuestsByEmail(['room', this.validEmails])
      if(res.success) this.cancel()
    },
    cancel() {
      this['modal/open']([InviteExternalGuestsModal])
    }
  },
  created() {
    this.$emit('modalSettings', {
      hasCloseButton: false
    })
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '~@/scss/components/modals/invite_users_modal.scss';
</style>
